const session_expired = {
    title: 'Sesja wygasła',
    subtitle: 'Twoja sesja mogła wygasnąć i zostałeś odłączony. Kliknij poniższy przycisk, aby ponownie się zalogować do konsoli administracyjnej.',
    button: 'Zaloguj się ponownie',
};
export default Object.freeze(session_expired);
